import { createContext } from '@chakra-ui/react-utils';
import type { ChangeEventHandler, FocusEventHandler } from 'react';

import type { SearchInputMode, SearchInputSize } from '../types';

export interface SearchInputContextProps {
  value?: string;
  size: SearchInputSize;
  paddingLeft?: string;
  paddingRight?: string;
  'aria-describedby'?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  mode: SearchInputMode;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isReadOnly?: boolean;
  isLiveMode?: boolean;
  isSubmitMode?: boolean;
  isLiveEnabled?: boolean;
  isSubmitEnabled?: boolean;
  onChange?: ChangeEventHandler;
  onFocus?: FocusEventHandler;
  onBlur?: FocusEventHandler;
  onClear?: () => void;
  onSubmit?: () => void;
}

const [SearchInputProvider, useSearchInputContext] =
  createContext<SearchInputContextProps>({
    name: 'SearchInputContext',
    errorMessage:
      'useSearchInputContext: `context` is undefined. Seems you used a SearchInput sub-component outside of a SearchInput wrapping box.',
  });

export { SearchInputProvider, useSearchInputContext };
